type MarketLabelSource = {
  name?: string
  description?: string
  outcomes?: Array<{ specifier?: string | null }>
}

const applySpecifierToDescription = (description: string, specifier?: string | null): string => {
  if (!description) return ''
  if (description.includes('{value}') && specifier) {
    return description.replace('{value}', specifier)
  }
  return description
}

/**
 * Label shown in market selectors and headers.
 * Prefer API `name` (includes account-specific alt_name when enabled).
 */
export const getMarketDisplayLabel = (market: MarketLabelSource): string => {
  const name = (market.name || '').trim()
  if (name) {
    return name
  }

  const specifier = market.outcomes?.[0]?.specifier
  return applySpecifierToDescription((market.description || '').trim(), specifier)
}
